module.exports = __webpack_public_path__ + "img/desc-2.3.5995de24.jpg";